import { useState } from 'react';
import AdminSchools from './AdminSchools';
import AdminChapters from './AdminChapters';
import AdminTools from './AdminTools';
import AdminReports from './AdminReports';

const AdminHome = ({ onViewContent, onEditContent, onViewActivities, onEditActivities, onUserManagement }) => { // eslint-disable-line no-unused-vars
  const [activeTab, setActiveTab] = useState('adminChapters');

  return (
    <>
      <div className="border-b border-gray-200 mx-4">
        <nav className="flex space-x-8">
          <button
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'adminChapters'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab('adminChapters')}
          >
            📚 Chapters
          </button>
          <button
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'adminSchools'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab('adminSchools')}
          >
            🏫 Schools
          </button>
          <button
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'adminTools'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab('adminTools')}
          >
            🛠️ Tools
          </button>
          <button
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'adminReports'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab('adminReports')}
          >
            📊 Reports
          </button>
          <button
            className="py-2 px-1 border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 font-medium text-sm transition-colors"
            onClick={onUserManagement}
          >
            👥 User Management
          </button>
        </nav>
      </div>

      <div className="bg-white shadow-sm rounded-lg m-4">
        <div className="p-6">
          {activeTab === 'adminSchools' && (
            <AdminSchools />
          )}
          {activeTab === 'adminTools' && (
            <AdminTools />
          )}
          {activeTab === 'adminReports' && (
            <AdminReports />
          )}
          {activeTab === 'adminChapters' && (
            <AdminChapters 
              onViewContent={onViewContent} 
              onEditContent={(ch) => onEditContent(ch)} 
              onViewActivities={(ch) => onViewActivities(ch)} 
              onEditActivities={(ch) => onEditActivities(ch)} 
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AdminHome;
